

export default function Paragraf({ parag, styles}) {
    return (
        <p className="text-5 line-height-2 text-dark" 
        style={{...styles}}> {parag} </p>
    )
}
